import GATSBY_COMPILED_MDX from "/Volumes/Extra/Documents/GitHub/cpboyd/gatsby-sites/packages/hvs-gatsby/content/posts/youtube/drag-brunch/2020/1028-murder-mystery-drag-brunch-strangled.mdx";
import * as React from 'react';
import YoutubeView from './youtube-view';
import {jsx as ___EmotionJSX} from "@emotion/react";
export {Head} from './youtube-view';
const Template = _ref => {
  let {data: {post}, children: mdxContent} = _ref;
  return ___EmotionJSX(YoutubeView, {
    post: post,
    mdxContent: mdxContent
  });
};
Template
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Template, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
const query = "3737795679";
